






























































































































    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { BNavbar, BNavbarBrand, BNavbarToggle, BNavbarNav, BNavItem, BNavForm, BCollapse, BFormInput, BButton, BNavItemDropdown, BDropdownItem, BImg, BNavText, BInputGroup, BInputGroupAppend, BAvatar, BDropdownText, BDropdownDivider, BNav, BTabs, BTab, BRow, BCol } from 'bootstrap-vue';
    import LocaleSwitcher from '@/components/LocaleSwitcher.vue';
    import Configuration from '@/types/Configuration';
    import InlineSvg from 'vue-inline-svg';
    import AvatarUtils from '@/types/AvatarUtils';

    @Component({
        components: {
            'b-navbar': BNavbar,
            'b-navbar-brand': BNavbarBrand,
            'inline-svg': InlineSvg,
            'b-navbar-toggle': BNavbarToggle,
            'b-collapse': BCollapse,
            'b-nav': BNav,
            'b-navbar-nav': BNavbarNav,
            'b-nav-item': BNavItem,
            'b-nav-text': BNavText,
            'b-nav-form': BNavForm,
            'b-input-group': BInputGroup,
            'b-input-group-append': BInputGroupAppend,
            'b-form-input': BFormInput,
            'b-button': BButton,
            'b-nav-item-dropdown': BNavItemDropdown,
            'b-dropdown-item': BDropdownItem,
            'b-dropdown-text': BDropdownText,
            'b-dropdown-divider': BDropdownDivider,
            'b-img': BImg,
            'locale-switcher': LocaleSwitcher,
            'b-avatar': BAvatar,
            'b-tabs': BTabs,
            'b-tab': BTab,
            'b-row': BRow,
            'b-col': BCol
        }
    })
    export default class Navbar extends Vue {
        @Prop() selectedOption!: string

        currentRoute: string | null | undefined = ''

        mounted() {
            this.currentRoute = this.$router.currentRoute.name;
        }

        get isAdmin() {
            return this.$appUser?.isAdministrator;
        }

        get userInitials() {
            if (this.$appUser) {
                return AvatarUtils.getUserInitials(this.$appUser.name);
            }

            return null;
        }

        get isTest() {
			return process.env.VUE_APP_ENV === 'test';
        }

        logout() {
            const authType = this.$store.state.authType;

            this.$store.dispatch('setApiAccessToken', '');
            this.$store.dispatch('setApiRefreshToken', '');
            this.$store.dispatch('setAppUser', null);
            this.$store.dispatch('setAuthType', '');
            this.$appUser = null;
            Vue.prototype.$appUser = null;

            // TODO: vidjeti je li ovo uopće potrebno
            // Brisanje MSAL cookija i svega iz storage-a što MSAL stavi mimo aplikacije
            //this.deleteAllMsalCookies();
            //this.deleteAllMsalStorageItems();

            if (authType == Configuration.AzureAuthType) {
                this.$msal.signOut();
            }
            else {
                this.$router.push({ path: '/login' });
            }
        }

        deleteAllMsalCookies() {
            const cookies = document.cookie.split(";");

            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i];
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie;
                if (name.indexOf('msal.') == 0) {
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
            }
        }

        deleteAllMsalStorageItems() {
            const arr = [];

            for (let i = 0; i < window.localStorage.length; i++) {
                const key = window.localStorage.key(i);
                if (key?.substring(0, 5) == 'msal.' || key?.indexOf('{"authority":') == 0) {
                    arr.push(localStorage.key(i));
                }
            }

            for (let i = 0; i < arr.length; i++) {
                localStorage.removeItem(arr[i] as string);
            }
        }
    }
